<template>
    <multiselect
        v-model="option"
        :options="options"
        track-by="key"
        label="value"
        :multiple="false"
        :allowEmpty="!!allowEmpty"
        placeholder="Tratamiento"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange">
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        name: "ReceiptMemberCalledSelector",
        components: {
            Multiselect
        },
        props: {
            value: Number,
            allowEmpty: Boolean
        },
        data: function () {
            return {
                options: [
                    {key: 1, value: 'Cobrar tras llamada'},
                    {key: 0, value: 'Cobrar sin llamar'}
                ],
                option: !!this.value ? this.findOptionByKey(this.value) : null
            }
        },
        methods: {
            findOptionByKey(key) {
                return this.options.find(option => (option.key === key));
            },
            notifyChange(option) {
                this.$emit('input', (!!option ? option.key : null));
            }
        },
        watch: {
            value: function () {
                if (!!this.value) {
                    this.option = this.findOptionByKey(this.value);
                }
            }
        }
    }
</script>

<style scoped>

</style>